<div class="modal-body p-md-5">
  <button type="button" class="close" data-dismiss="modal" (click)="close()"><i class="icon-close"></i></button>
  <h2 class="mg-b30 font-24 montserrat-medium">Give Feedback</h2>
    <div class="form-group mb-4 new-options">
      <textarea class="new-options--input medium" placeholder="Type your response here"
        [(ngModel)]="text"></textarea>
    </div>
    <div class="text-center">
      <button class="btn btn-primary long-btn50" data-dismiss="modal" (click)="submitFeedback()" [disabled]="!text"><span>Submit</span></button>
    </div>
</div>
